import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { VirtualTimeScheduler } from 'rxjs';
import { GetAllUnacceptedCustomersService } from 'src/app/shared/moderator/approve-customer/approve-customer.service';
import { ModeratorService } from 'src/app/shared/moderator/moderator.service';
import { LoginService } from 'src/app/shared/user-login/login.service';

@Component({
    selector: 'app-get-all-unapproved-customers',
    templateUrl: './get-all-unapproved-customers.component.html',
    styleUrls: ['./get-all-unapproved-customers.component.css'],
    standalone: false
})
export class GetAllUnapprovedCustomersComponent implements OnInit {
  unapprovedCustomers: []
  role
  experts: []
  serverErrorMessages: string
  loading: boolean = true;
  constructor(private loginService: LoginService, private getAllUnacceptedCustomersService: GetAllUnacceptedCustomersService, private router : Router) { }

  ngOnInit(): void {
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
          this.role = res['user'].role.toString();
         //console.log('User', this.role);
          this.loading = false;
          this.getAllUnapprovedCustomers();
        },
        err => {
         //console.log('Didnt get logged in user', err);
          this.serverErrorMessages = err.error.message;
          this.loading = false;
        }
      )
    }
  }

  getAllUnapprovedCustomers(){
    this.getAllUnacceptedCustomersService.getAllUnapprovedCustomers().subscribe(
      res => {
       //console.log('Got unapproved customers', res)
        this.unapprovedCustomers = res['customers']
       //console.log(this.unapprovedCustomers)
      },
      err => {
       //console.log('error', err)
      }
    )
  }

  unauthorised(){
    setTimeout(() => {
      this.loginService.deleteToken();
     //console.log('BYE BYE');
      this.router.navigateByUrl('/signin');
    }, 3000);
  }

  checkThisCustomer(unapprovedCustomer){
   //console.log(unapprovedCustomer)
    this.getAllUnacceptedCustomersService.changecustomer(unapprovedCustomer)
    this.router.navigateByUrl('/check-customer')
  }

}
